
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  A Hero banner displays a prominent message and related action. Banners are
  displayed on the homepage below the site header of European Commission sites.
  It conveys an important message to your audience. Hero banners are a good way
  to channel your visitors to complete a specific task, for example register to
  an event or apply for funding. The user can choose to ignore them or interact
  with them at any time.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <p>{`Banners display a focused message and provide users with clear action to take. They are placed at the top of the page below the site header.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Hero%20Banner/Hero%20Banner01.jpg",
        "alt": "hero banner"
      }}></img></p>
    <p>{`Hero banner images have an aspect ratio of 3:1, meaning the width will be always three times the height of the images.`}</p>
    <p><img parentName="p" {...{
        "src": "https://inno-ecl.s3.amazonaws.com/media/images/EC/Hero%20Banner/Hero%20Banner02.png",
        "alt": "hero banner 2"
      }}></img></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Components`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Constraint`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Restrictions`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hero image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`optional`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`choice between 2 background colours when there is no image`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`description`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`mandatory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100-150 characters maximum, including punctuation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`call to action`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`mandatory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`3 words – 25 characters maximum, including punctuation`}</td>
        </tr>
      </tbody>
    </table>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`Exclusively on the campaign websites`}</li>
      <li parentName="ul">{`To communicate important messages channeling the user to take an action.`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`Do not use more than one banner at a time.`}</li>
      <li parentName="ul">{`Do not use on a website other than campaign.`}</li>
    </ul>
    <h2>{`DO's`}</h2>
    <ul>
      <li parentName="ul">{`The supporting illustration is:`}<ul parentName="li">
          <li parentName="ul">{`relevant`}</li>
          <li parentName="ul">{`high quality`}</li>
          <li parentName="ul">{`emotionally persuasive`}</li>
          <li parentName="ul">{`the minimum ratio is 3:1`}</li>
        </ul></li>
    </ul>
    <h2>{`DON'Ts`}</h2>
    <ul>
      <li parentName="ul">{`Use more than one banner per page`}</li>
      <li parentName="ul">{`Use banner on pages other than homepage or landing pages`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;